"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permission = void 0;
require("core-js/modules/es.error.cause.js");
var _admin = require("@/store/modules/admin");
const permission = exports.permission = {
  inserted(el, binding) {
    const {
      value
    } = binding;
    const roles = _admin.AdminModule.roles;
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value;
      const hasPermission = roles.some(role => {
        return permissionRoles.includes(role);
      });
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error('need roles! Like v-permission="[\'superadmin\',\'admin\',\'executive\']"');
    }
  }
};